<template>
  <navbar>
    <my-button @click="$router.push('/auth/log_in')">log in</my-button>
  </navbar>

  <div class="form">
    <div class="error_msg" v-if="isError">{{ error_msg }}</div>
    <form class="form__content" @submit.prevent="singin">
      <my-input v-model="user.username" class="bar_input" placeholder="username" type="username"/>
      <my-input v-model="user.name"     class="bar_input" placeholder="your name"/>
      <my-input v-model="user.password" class="bar_input" placeholder="password" type="password"/>
      <my-input v-model="user.code"     class="bar_input" placeholder="code"/>
      <my-button style="width: auto; margin-top: 25px;">Sing in</my-button>
    </form>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';
// import ky from 'ky';
import sha256 from 'js-sha256';

export default {
  components: {
    Navbar
  },
  data() {
    return {
      user: {username: '', name: '', password: '', code: ''},
      isError: false,
      error_msg: '',
    }
  },
  methods: {
    async singin(event) {
      // const data = await ky.post('http://127.0.0.1:48448/auth/log_in',
      //   {
      //     json: {
      //       username: this.user.username,
      //       password: sha256(this.user.password),
      //     }
      //   }
      // );
      let res = await fetch('/api/auth/sign_in', {
      // let res = await fetch('/auth/log_in', {
        method: "POST",
        // credentials: 'include',
        headers: {"content-type": "application/json"},
        body: JSON.stringify({
          username: this.user.username,
          name:     this.user.name,
          password: sha256(this.user.password),
          code:     this.user.code,
        })
      })
      if (res.status === 200) {
        this.$router.push('/bar')
      } else if (res.status === 401) {
        let answer = await res.json();
        this.isError = true;
        this.error_msg = answer.error;
      } else if (res.status === 422) {
        this.isError = true;
        this.error_msg = 'incorrect data';
      }
      // console.log(res);
      // console.log(await res.json());
      // console.log(await res.headers.get('bar_token'));
    }
    // async load() {
    //   const json = await ky.get
    // }
  },
  mounted() {
    // load();
  }
}
</script>


<style scoped>
.form {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  /* text-align: center; */
  /* padding: 50px; */
}
.form__content {
  display: flex;
  flex-direction: column;
  margin: auto;
  /* text-align: center; */
  /* justify-self: center; */
}
.error_msg {
  color: red;
  font-size: 25px;
  border: 2px solid red;
  border-radius: 10px;
  padding: 5px;
  text-align: center;
  width: max-content;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;

  animation: l1 1s linear infinite alternate;
}
@keyframes l1 {to{opacity: 0}}
</style>
